import { v4 as uuidv4 } from 'uuid';

import { formatTimeStamp } from 'src/utils/formatTime';

import { genericApiToaster } from 'src/services/utils';
import { uploadFile } from 'src/services/ticket.service';

export const directUpload = async ({
  files,
  ticketId,
  resetFiles,
  onUpload,
  setUploadProgress,
  setDropzoneEnabled,
  setIsUploading,
  hideModal,
  showToast,
  hideToast,
  t,
}) => {
  try {
    const uploadPromises = files.map(async (file) => {
      const timeStamp = formatTimeStamp(Date.now());
      const fileExtMatch = file.name.match(/\.([^.]+)$/);
      const extension = fileExtMatch ? fileExtMatch[0] : '';
      const baseName = file.name.replace(/\.[^.]+$/, '');
      const newFileName = `${baseName}_${timeStamp}${extension}`;

      const updatedFile = new File([file], newFileName, { type: file.type });
      const formData = new FormData();
      formData.append('files', updatedFile);

      await genericApiToaster(
        uploadFile,
        [
          formData,
          ticketId,
          (progressEvent) => {
            const progress = Math.round(
              (progressEvent.loaded / progressEvent.total) * 100
            );
            setUploadProgress(progress);
          },
        ],
        '',
        t('errorMessages.couldntUploadFile'),
        showToast,
        hideToast,
        t,
        () => {
          if (onUpload) onUpload(newFileName);
        }
      );
    });

    await Promise.all(uploadPromises);
    resetFiles();
    if (hideModal) hideModal();
    showToast({
      message: t('successMessages.fileUploadSuccess'),
      severity: 'success',
      props: { hideToast },
    });
  } catch (error) {
    showToast({
      message: t('errorMessages.uploadFailed'),
      severity: 'error',
      props: { hideToast },
    });
  } finally {
    setIsUploading(false);
    setDropzoneEnabled(false);
  }
};

export const formDataUpload = async ({
  files,
  setAttachmentId,
  setFormData,
  setFilesList,
  showToast,
  hideToast,
  setIsUploading,
  setFileChosen,
  t,
}) => {
  try {
    const fileNames = [];
    const attachmentData = new FormData();

    files.forEach((file) => {
      const id = uuidv4();
      setAttachmentId(id);
      const timeStamp = formatTimeStamp(Date.now());
      const fileExtMatch = file.name.match(/\.([^.]+)$/);
      const extension = fileExtMatch ? fileExtMatch[0] : '';
      const baseName = file.name.replace(/\.[^.]+$/, '');
      const newFileName = `${baseName}_${timeStamp}${extension}`;

      const updatedFile = new File([file], newFileName, { type: file.type });
      attachmentData.append(id, updatedFile);
      fileNames.push(newFileName);
    });

    if (setFormData) setFormData(attachmentData);
    if (setFilesList) setFilesList(fileNames);

    showToast({
      message: t('successMessages.fileAddedSuccessfully'),
      severity: 'success',
      props: { hideToast },
    });
    setFileChosen(true);
  } catch (error) {
    showToast({
      message: t('errorMessages.preparingFilesFailed'),
      severity: 'error',
      props: { hideToast },
    });
  } finally {
    setIsUploading(false);
  }
};
